import moment from "moment";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Badge, CardHeader, Form, Input, Label, Spinner } from "reactstrap";
 

import { toast } from "react-toastify";
import Required from "../form/Required";
import MyLoader from "../form/MyLoader";
import useLogout from "../../../hooks/useLogout";
import { Button, Col, Icon, PreviewAltCard, Row } from "../../../components/Component";

const ApiPaginationDataTable = ({
  data,
  columns,
  title,
  isLoading,
  className,
  handleTabClick,
  showSecondTable,
  activeTab,
  handleBackClick,
  watch,
  showThirdTable,
  handleThirdTableBackClick,
  search,
  selectableRows,
  zoneList,
  tabs,
  handleImageOpenPreview,
  owner,
  exp,
  keysToExport,
  setValue,
  register,
  errors,
  trigger,
  handleSubmit,
  handleSearch,
  searchPlaceholder, //search placeholder
  date, //to enable date filter
  type, //to enable type filter
  zone, //to enable zone filter
  camp, //to enable camp filter
  campReq, //to enable required on camp
  handlePerRowsChange,
  handlePageChange,
  totalRows,
  perPage,
  dashTab, //to enable tabs in dashboard card click
  serverSearch, // to enable server side search
  serverSideSearch, //function to initiate search
  campUser,
  pos,
  session, //to get session
  Class, // to get class
  subject, // get subject
  subjectReq, //enable required in subject
  chapter,
  chapterReq,
}) => {
  const { t } = useTranslation();
  const IMAGE_BASE_URL = localStorage.getItem("IMAGE_BASE_URL");
  // Customizing pagination text and no data component
  const paginationComponentOptions = {
    rowsPerPageText: "Rows per page",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };
  const customStyles = {
    headRow: {
      style: {
        border: "none",
      },
    },
    headCells: {
      style: {
        color: "#202124",
        fontSize: "14px",
      },
    },
    rows: {
      highlightOnHoverStyle: {
        backgroundColor: "rgb(230, 244, 244)",
        borderBottomColor: "#FFFFFF",
        borderRadius: "1px",
        outline: "1px solid #FFFFFF",
      },
    },
    pagination: {
      style: {
        border: "none",
      },
    },
  };

  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState(data);
  const logout = useLogout();
  useEffect(() => {
    let filteredData = data;
    switch (title) {
      case "Employee List":
        filteredData = data.filter((item) => {
          const filter = filterText.toLowerCase();
          const fullname = `${item.first_name} ${item.last_name}`;
          return (
            (fullname && fullname.toLowerCase().includes(filter)) ||
            (item.phone && item.phone.toLowerCase().includes(filter)) ||
            (item.pincode && item.pincode.toLowerCase().includes(filter)) ||
            (item.role && item.role.toLowerCase().includes(filter))
          );
        });
        break;
      case "Ward List":
        filteredData = data.filter((item) => {
          const filter = filterText.toLowerCase();
          return (
            (item.label && item.label.toLowerCase().includes(filter)) ||
            (item.zone_name && item.zone_name.toLowerCase().includes(filter)) ||
            (item.ward_code && item.ward_code.toLowerCase().includes(filter))
          );
        });
        break;
      default:
        break;
    }
    setFilteredItems(filteredData);
  }, [filterText, data, title]);

 

  const result = filteredItems?.map((item) =>
    Object?.fromEntries(Object?.entries(item)?.filter(([key]) => keysToExport?.includes(key)))
  );

  const handleSessionChange = (selectedOption) => {
    setValue("session", selectedOption);
    trigger("session");
  };
  const handleSubjectChange = (e) => {
    setValue("subject", e);
    trigger("subject");
    const body = {
      subject_id: e?.value,
    };
    // getChapterBySUbjectLMSDD(body)
    //   .then((res) => {
    //     const status = res.data.status;
    //     if (status) {
    //       setValue("chapterList", res.data.data);
    //     } else if (!status) {
    //       setValue("chapterList", []);
    //     } else if (status === "expired") {
    //       toast.error(res.data.message);
    //       toast.clearWaitingQueue();
    //       logout();
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("Err", err);
    //   });
  };
  const handleChapterChange = (opt) => {
    setValue("chapter", opt);
  };
  const handleClassChange = (e) => {
    setValue("class", e);
    trigger("class");
    const body = {
      class_id: e?.value,
    };
    // getSubjectByClassLMSDD(body)
    //   .then((res) => {
    //     const status = res.data.status;
    //     if (status) {
    //       setValue("subjectList", res.data.data);
    //     } else if (!status) {
    //       setValue("subjectList", []);
    //     } else if (status === "expired") {
    //       toast.error(res.data.message);
    //       toast.clearWaitingQueue();
    //       logout();
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("Err", err);
    //   });
  };
  const rowsPerPageOptions = [25, 50, 100, 500];
  return (
    <>
      <Row>
        <Col sm="12">
          <PreviewAltCard className={`my-2`}>
            <CardHeader>
              <div className="d-flex justify-content-between align-items-center">
                <h5>{title}</h5>
                {dashTab && (
                  <>
                    <div className="d-flex align-items-center justify-content-between">
                      <ul className="card-tools-nav mb-2" style={{ justifyContent: "end" }}>
                        {/* <li className="d-flex align-items-center">
                        <Button color={`primary`} size={`xs`} onClick={() => handleBackClick()}>
                          <Icon name={"arrow-long-left"} className={`me-1`} />
                          {t("Back")}
                        </Button>
                      </li> */}
                        <li className={activeTab === "Owner" ? "active" : ""} onClick={() => handleTabClick("Owner")}>
                          <a
                            href="#owner"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className=""
                          >
                            <Badge className="" color="primary">
                              {watch("ownerList")?.length}
                            </Badge>
                            <span className="me-1"> {"Owner"}</span>
                          </a>
                        </li>
                        <li className={activeTab === "Driver" ? "active" : ""} onClick={() => handleTabClick("Driver")}>
                          <a
                            href="#driver"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className=""
                          >
                            <Badge className="" color="primary">
                              {watch("driverList")?.length}
                            </Badge>
                            <span className="me-1"> {"Driver"}</span>
                          </a>
                        </li>

                        <li
                          className={activeTab == "Vehicle" ? "active" : ""}
                          onClick={() => handleTabClick("Vehicle")}
                        >
                          <a
                            href="#vehicle"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className=""
                          >
                            <Badge className="" color="primary">
                              {watch("vehicleList")?.length}
                            </Badge>
                            <span className="mx-1">{"Vehicle"}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </>
                )}

                {showThirdTable && (
                  <ul className="card-tools-nav mb-2" style={{ justifyContent: "end" }}>
                    <li className="d-flex align-items-center">
                      <Button color={`primary`} size={`xs`} onClick={() => handleThirdTableBackClick()}>
                        <Icon name={"arrow-long-left"} className={`me-1`} />
                        {"Back"}
                      </Button>
                    </li>
                  </ul>
                )}
                {campUser && (
                  <div className="d-flex align-items-center justify-content-end">
                    {
                      <ul className="card-tools-nav mb-2" style={{ justifyContent: "end" }}>
                        <li className="d-flex align-items-center">
                          <Button color={`primary`} size={`xs`} onClick={() => handleBackClick()}>
                            <Icon name={"arrow-long-left"} className={`me-1`} />
                            {"Back"}
                          </Button>
                        </li>
                        <li className={activeTab === "Owner" ? "active" : ""} onClick={() => handleTabClick("Owner")}>
                          <a
                            href="#owner"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className=""
                          >
                            <Badge className="" color="primary">
                              {watch("ownerList")?.length}
                            </Badge>
                            <span className="me-1"> {"Owner"}</span>
                          </a>
                        </li>
                        <li
                          className={activeTab == "Vehicle" ? "active" : ""}
                          onClick={() => handleTabClick("Vehicle")}
                        >
                          <a
                            href="#vehicle"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className=""
                          >
                            <Badge className="" color="primary">
                              {watch("vehicleList")?.length}
                            </Badge>
                            <span className="mx-1">{"Vehicle"}</span>
                          </a>
                        </li>
                        <li className={activeTab === "Driver" ? "active" : ""} onClick={() => handleTabClick("Driver")}>
                          <a
                            href="#driver"
                            onClick={(ev) => {
                              ev.preventDefault();
                            }}
                            className=""
                          >
                            <Badge className="" color="primary">
                              {watch("driverList")?.length}
                            </Badge>
                            <span className="me-1"> {"Driver"}</span>
                          </a>
                        </li>
                      </ul>
                    }
                  </div>
                )}
              </div>
            </CardHeader>

            <div className="nk-data data-list">
              {search && (
                <div>
                  <Form onSubmit={handleSubmit(handleSearch)}>
                    <Row className={`g-gs`}>
                      {/* Zone */}
                      {session && (
                        <Col md="4" sm="4" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="session">
                              {"Session"}
                              <Required />
                            </Label>

                            <Select
                              id="session"
                              placeholder={"Please select session"}
                              options={watch("sessionList")}
                              {...register("session", { required: { value: true, message: "Please select zone" } })}
                              onChange={handleSessionChange}
                              value={watch("session")}
                            />
                            {errors.session && <span className="invalid">{errors.session.message}</span>}
                          </div>
                        </Col>
                      )}
                      {Class && (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="class">
                              {"Class"}
                              <Required />
                            </Label>

                            <Select
                              id="class"
                              placeholder={"Please select class"}
                              options={watch("classList")}
                              {...register("class", { required: { value: false, message: "Please select class" } })}
                              onChange={handleClassChange}
                              value={watch("class")}
                            />
                            {errors.class && <span className="invalid">{errors.class.message}</span>}
                          </div>
                        </Col>
                      )}
                      {subject && (
                        <Col md="4" sm="3" xxl="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="subject">
                              {"Subject"}
                              {subjectReq && <Required />}
                            </Label>
                            <Select
                              id="subject"
                              placeholder={"Please select subject"}
                              options={watch("subjectList")}
                              {...register("subject", { required: { value: false, message: "Please select subject" } })}
                              onChange={handleSubjectChange}
                              value={watch("subject")}
                            />
                            {errors.subject && <span className="invalid">{errors.subject.message}</span>}
                          </div>
                        </Col>
                      )}
                      {chapter && (
                        <Col md="4" sm="3" xxl="4">
                          <div className="form-group">
                            <Label className="form-label" htmlFor="chapter">
                              {"Chapter"}
                              {subjectReq && <Required />}
                            </Label>
                            <Select
                              id="chapter"
                              placeholder={"Please select chapter"}
                              options={watch("chapterList")}
                              {...register("chapter", { required: { value: false, message: "Please select chapter" } })}
                              onChange={handleChapterChange}
                              value={watch("chapter")}
                            />
                            {errors.chapter && <span className="invalid">{errors.chapter.message}</span>}
                          </div>
                        </Col>
                      )}

                      {/* From Date */}
                      {date && (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label htmlFor="from_date" className="form-label">
                              {"From Date"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <DatePicker
                                id="from_date"
                                className="form-control date-picker"
                                placeholderText={"Please choose date"}
                                {...register("from_date", {
                                  required: "from date is required",
                                })}
                                onChange={(date) => {
                                  const formattedDate = moment(date).format("DD-MMM-YYYY"); // Format the date here
                                  setValue("from_date", date); // Save the formatted date
                                  trigger("from_date");
                                }}
                                selected={watch("from_date")}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                minDate={moment().subtract(70, "years").toDate()}
                                showYearDropdown
                                scrollableYearDropdown
                                dropdownMode="select"
                                showMonthDropdown
                                // yearDropdownItemNumber={12}
                              />
                            </div>
                            {errors.from_date && <p className="invalid">{errors.from_date.message}</p>}
                          </div>
                        </Col>
                      )}
                      {/* To Date */}
                      {date && (
                        <Col md="4" sm="3" xxl="2">
                          <div className="form-group">
                            <Label htmlFor="to_date" className="form-label">
                              {"To Date"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <DatePicker
                                id="to_date"
                                className="form-control date-picker"
                                placeholderText={"Please choose date"}
                                {...register("to_date", {
                                  required: "to date is required",
                                })}
                                onChange={(date) => {
                                  const formattedDate = moment(date).format("DD-MMM-YYYY"); // Format the date here
                                  setValue("to_date", date); // Save the formatted date
                                  trigger("to_date");
                                }}
                                selected={watch("to_date") || new Date()}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                minDate={watch("from_date")}
                                showYearDropdown
                                scrollableYearDropdown
                                dropdownMode="select"
                                // withPortal

                                showMonthDropdown
                                // yearDropdownItemNumber={12}
                              />
                            </div>
                            {errors.to_date && <p className="invalid">{errors.to_date.message}</p>}
                          </div>
                        </Col>
                      )}
                    </Row>
                    <Button disabled={isLoading} className={`my-2`} color={`primary`}>
                      {isLoading ? <Spinner size="sm" color="light" /> : "Submit"}
                    </Button>
                  </Form>
                </div>
              )}

              <div className={`chat-box ${tabs ? "d-flex justify-content-between" : ""}`}>
                <div className="people-list ">
                  <div className="search d-flex justify-content-between">
                    {serverSearch ? (
                      <div className={`form-control-wrap`}>
                        <div className="form-icon form-icon-right xl">
                          <Icon
                            name="search"
                            style={{
                              position: "absolute",
                              top: "20%",
                              right: "10px",
                            }}
                          ></Icon>
                        </div>
                        <Input
                          className="form-control"
                          type="text"
                          placeholder={searchPlaceholder || "search"}
                          value={watch("server_search")}
                          onChange={(e) => setValue("server_search", e.target.value)}
                          style={{ width: "360px" }}
                        />
                        {watch("server_search")?.length > 0 && (
                          <Button
                            className={`my-1`}
                            size={`xs`}
                            outline
                            color="primary"
                            onClick={() => serverSideSearch(watch("server_search"), title)}
                          >
                            Search
                          </Button>
                        )}
                      </div>
                    ) : (
                      <Form className="theme-form">
                        <div className={`form-control-wrap`}>
                          <div className="form-icon form-icon-right xl">
                            <Icon
                              name="search"
                              style={{
                                position: "absolute",
                                top: "20%",
                                right: "10px",
                              }}
                            ></Icon>
                          </div>
                          <Input
                            className="form-control"
                            type="text"
                            placeholder={searchPlaceholder || "search"}
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                            style={{ width: "360px" }}
                          />
                          {/* <i className="fa fa-search"></i> */}
                        </div>
                      </Form>
                    )}
                    {/* {exp ? <Export sheetName={title} data={result} /> : null} */}
                  </div>
                </div>

                {tabs && (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <ul className="card-tools-nav mb-2" style={{ justifyContent: "end" }}>
                        {zoneList?.map((item, index) => (
                          <li
                            key={index}
                            className={activeTab === item?.label ? "active" : ""}
                            onClick={() => handleTabClick(item)}
                          >
                            <a
                              href={`#${item?.label}`}
                              onClick={(ev) => {
                                ev.preventDefault();
                              }}
                              className="d-flex align-items-center"
                            >
                              {item?.zone_color && (
                                <span
                                  className={`dot dot-${item?.zone_color} m-1`}
                                  style={{ backgroundColor: item?.zone_color }}
                                ></span>
                              )}
                              <span className="me-1"> {t(item?.label)}</span>
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </>
                )}
              </div>
              <DataTable
                className={className}
                columns={columns}
                data={filteredItems}
                progressPending={isLoading}
                progressComponent={<MyLoader />}
                noDataComponent={"There are no records to display"}
                subHeader={false}
                persistTableHead
                onColumnOrderChange
                striped={true}
                responsive={true}
                highlightOnHover
                customStyles={customStyles}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationPerPage={perPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                // paginationRowsPerPageOptions={[50, 100, 500,totalRows]} // Only numbers
                paginationRowsPerPageOptions={rowsPerPageOptions}
                paginationComponentOptions={{
                  rowsPerPageText: "Rows per page",
                  selectAllRowsItem: true, // enables the "All" option
                  selectAllRowsItemText: "All", // label shown for the "All" option
                }}
              />
            </div>
          </PreviewAltCard>
        </Col>
      </Row>
    </>
  );
};

export default ApiPaginationDataTable;
